
export interface DualHttpsOnlyPair {
    id: string
    primaryIp: string
    secondaryIp: string
    port?: number
    /** Include this pair in RC dual_https on next update (not in ips). */
    enabled?: boolean
}

export interface BMServer {
    serverName: string;
    traffic: number;
    ips: IP[]
    currentIp: string
    updatedBy: string
    updatedOn: number
    link: string
    hasBadTraffic: boolean
    serverType?: string // "gaming", "streaming", "general"
    app?: string // "ALL", "KARAK", "SPL"
    isPremium?: boolean
    manualRegion?: string
    /** Pairs that only go into dual_https.pairs — never into ips (old apps never see them). */
    dualHttpsOnlyPairs?: DualHttpsOnlyPair[]
}
export enum IP_STATUS {
    ACTIVE = "ACTIVE", NEW = "NEW", BLOCKED = "BLOCKED", DISABLED = "DISABLED"
}
export interface IP {
    ip: string;
    status: IP_STATUS
    /** Dual HTTPS secondary host/IP for this primary (no port). */
    secondaryIp?: string
    /** Port used in dual_https.pairs for this primary (default 443). */
    dualHttpsPort?: number
    /** When true, include this primary in dual_https.pairs (if secondary is set). */
    dualHttpsEnabled?: boolean
}
export interface BMServerToUpdate extends BMServer {
    newIp: string
    reason: string
    dualHttpsEnabled?: boolean
}
